// The org's own currency. A byte-for-byte copy of the dashboard's 16 inline
// `countryCode === 'CA'` checks, so CON-320 can replace them as a pure refactor: an exact,
// case-sensitive match, so a lower-case 'ca' is USD, as at those call sites today.
export function orgCurrency(merchant) {
  return merchant?.countryCode === 'CA' ? 'CAD' : 'USD';
}
